"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DepositResumeOperation = exports.CrossResumeOperation = exports.CrossOperation = exports.CreateChainOperation = exports.RemoveSupernetValidatorOperation = exports.AddSupernetValidatorOperation = exports.CreateSupernetOperation = exports.DelegatePrimaryOperation = exports.ValidatePrimaryOperation = exports.Staking = exports.EthCallOperation = exports.UnwrapOperation = exports.WrapOperation = exports.SendUtxoOperation = exports.MultiSigUtxoOperation = exports.SendOperation = exports.NetworkOperationStatus = exports.ChainNetworkOperation = exports.NetworkOperationRange = exports.NetworkOperationType = void 0;
const transaction_1 = require("../../transaction");
const utils_1 = require("../../utils");
var NetworkOperationType;
(function (NetworkOperationType) {
    NetworkOperationType["Send"] = "Send";
    NetworkOperationType["SendUtxo"] = "Send utxo";
    NetworkOperationType["Cross"] = "Cross";
    NetworkOperationType["CrossResume"] = "Cross resume";
    NetworkOperationType["DepositResume"] = "Deposit resume";
    NetworkOperationType["Bridge"] = "Bridge";
    NetworkOperationType["ValidatePrimary"] = "Validate primary";
    NetworkOperationType["DelegatePrimary"] = "Delegate primary";
    NetworkOperationType["Wrap"] = "Wrap";
    NetworkOperationType["Unwrap"] = "Unwrap";
    NetworkOperationType["CreateSupernet"] = "Create supernet";
    NetworkOperationType["ValidateSupernet"] = "Validate supernet";
    NetworkOperationType["RemoveSupernetValidator"] = "Remove supernet validator";
    NetworkOperationType["CreateChain"] = "Create chain";
    NetworkOperationType["EthCall"] = "Eth call";
})(NetworkOperationType || (exports.NetworkOperationType = NetworkOperationType = {}));
var NetworkOperationRange;
(function (NetworkOperationRange) {
    NetworkOperationRange["Chain"] = "Chain";
    NetworkOperationRange["Supernet"] = "Supernet";
    NetworkOperationRange["MCN"] = "MCN";
})(NetworkOperationRange || (exports.NetworkOperationRange = NetworkOperationRange = {}));
class ChainNetworkOperation {
    type;
    range = NetworkOperationRange.Chain;
    chain;
    constructor(type, chain) {
        this.type = type;
        this.chain = chain;
    }
}
exports.ChainNetworkOperation = ChainNetworkOperation;
var NetworkOperationStatus;
(function (NetworkOperationStatus) {
    NetworkOperationStatus["Initializing"] = "Initializing";
    NetworkOperationStatus["Executing"] = "Executing";
    NetworkOperationStatus["Done"] = "Done";
    NetworkOperationStatus["Timeout"] = "Timeout";
    NetworkOperationStatus["Error"] = "Error";
})(NetworkOperationStatus || (exports.NetworkOperationStatus = NetworkOperationStatus = {}));
class SendOperation extends ChainNetworkOperation {
    assetId;
    amount;
    address;
    constructor(chain, assetId, amount, address) {
        super(NetworkOperationType.Send, chain);
        this.assetId = assetId;
        this.amount = amount;
        this.address = address;
    }
}
exports.SendOperation = SendOperation;
class MultiSigUtxoOperation extends ChainNetworkOperation {
    utxoSet;
    constructor(type, chain, utxoSet) {
        super(type, chain);
        this.utxoSet = utxoSet;
    }
    getPreferredUtxoSet(account, amount) {
        if (typeof this.utxoSet === 'undefined') {
            return account.utxoSet;
        }
        // adding a fee utxo allows the user to fully spend the chosen utxos
        const feeUtxos = (0, utils_1.getUtxoSetAssetAmountUtxos)(account.utxoSet, this.chain.assetId, amount, this.utxoSet.utxos);
        return [...this.utxoSet.utxos, ...feeUtxos];
    }
    getPreferredSigners(account) {
        return typeof this.utxoSet === 'undefined'
            ? transaction_1.Address.toAddresses(account.getSignersAddresses())
            : [...transaction_1.Address.toAddresses(account.getSignersAddresses()), ...this.utxoSet.getSelectedSigners()];
    }
}
exports.MultiSigUtxoOperation = MultiSigUtxoOperation;
class SendUtxoOperation extends MultiSigUtxoOperation {
    assetId;
    amount;
    addresses;
    threshold;
    locktime;
    stakeable;
    constructor(chain, assetId, amount, addresses, threshold, locktime = BigInt(0), stakeable = false) {
        super(NetworkOperationType.SendUtxo, chain);
        this.assetId = assetId;
        this.amount = amount;
        this.addresses = addresses;
        this.threshold = threshold;
        this.locktime = locktime;
        this.stakeable = stakeable;
    }
}
exports.SendUtxoOperation = SendUtxoOperation;
class JEVMChainOperation extends ChainNetworkOperation {
    chain;
    constructor(type, chain) {
        super(type, chain);
        this.chain = chain;
    }
}
class Wrapping extends JEVMChainOperation {
    asset;
    amount;
    constructor(type, chain, asset, amount) {
        super(type, chain);
        this.asset = asset;
        this.amount = amount;
    }
}
class WrapOperation extends Wrapping {
    constructor(chain, asset, amount) {
        super(NetworkOperationType.Wrap, chain, asset, amount);
    }
}
exports.WrapOperation = WrapOperation;
class UnwrapOperation extends Wrapping {
    constructor(chain, asset, amount) {
        super(NetworkOperationType.Unwrap, chain, asset, amount);
    }
}
exports.UnwrapOperation = UnwrapOperation;
class EthCallOperation extends JEVMChainOperation {
    contract;
    abi;
    functionName;
    values;
    amount;
    constructor(chain, contract, abi, functionName, values, amount) {
        super(NetworkOperationType.EthCall, chain);
        this.contract = contract;
        this.abi = abi;
        this.functionName = functionName;
        this.values = values;
        this.amount = amount;
    }
}
exports.EthCallOperation = EthCallOperation;
class Staking extends MultiSigUtxoOperation {
    nodeId;
    amount;
    stakePeriod;
    stakeAddresses;
    stakeThreshold;
    rewardAddresses;
    rewardThreshold;
    constructor(type, chain, nodeId, amount, stakePeriod, stakeAddresses, stakeThreshold, rewardAddresses, rewardThreshold) {
        super(type, chain);
        this.nodeId = nodeId;
        this.amount = amount;
        this.stakePeriod = stakePeriod;
        this.stakeAddresses = stakeAddresses;
        this.stakeThreshold = stakeThreshold;
        this.rewardAddresses = rewardAddresses;
        this.rewardThreshold = rewardThreshold;
    }
    getPreferredUtxoSet(account, amount) {
        if (typeof this.utxoSet === 'undefined') {
            return account.utxoSetStakeable;
        }
        // adding a fee utxo allows the user to fully spend the chosen utxos
        const feeUtxos = (0, utils_1.getUtxoSetAssetAmountUtxos)(account.utxoSetStakeable, this.chain.assetId, amount, this.utxoSet.utxos);
        return [...this.utxoSet.utxos, ...feeUtxos];
    }
}
exports.Staking = Staking;
class ValidatePrimaryOperation extends Staking {
    publicKey;
    signature;
    constructor(chain, nodeId, publicKey, signature, amount, stakePeriod, stakeAddresses, stakeThreshold, rewardAddresses, rewardThreshold) {
        super(NetworkOperationType.ValidatePrimary, chain, nodeId, amount, stakePeriod, stakeAddresses, stakeThreshold, rewardAddresses, rewardThreshold);
        this.publicKey = new transaction_1.BLSPublicKey(publicKey);
        this.signature = new transaction_1.BLSSignature(signature);
    }
}
exports.ValidatePrimaryOperation = ValidatePrimaryOperation;
class DelegatePrimaryOperation extends Staking {
    constructor(chain, nodeId, amount, stakePeriod, stakeAddresses, stakeThreshold, rewardAddresses, rewardThreshold) {
        super(NetworkOperationType.DelegatePrimary, chain, nodeId, amount, stakePeriod, stakeAddresses, stakeThreshold, rewardAddresses, rewardThreshold);
    }
}
exports.DelegatePrimaryOperation = DelegatePrimaryOperation;
class CreateSupernetOperation extends ChainNetworkOperation {
    supernetAuthAddresses;
    supernetAuthThreshold;
    constructor(chain, supernetAuthAddresses, supernetAuthThreshold) {
        super(NetworkOperationType.CreateSupernet, chain);
        this.supernetAuthAddresses = supernetAuthAddresses;
        this.supernetAuthThreshold = supernetAuthThreshold;
    }
}
exports.CreateSupernetOperation = CreateSupernetOperation;
class AddSupernetValidatorOperation extends ChainNetworkOperation {
    supernetId;
    nodeId;
    amount;
    stakePeriod;
    constructor(chain, supernetId, nodeId, amount, stakePeriod) {
        super(NetworkOperationType.ValidateSupernet, chain);
        this.supernetId = supernetId;
        this.nodeId = nodeId;
        this.amount = amount;
        this.stakePeriod = stakePeriod;
    }
}
exports.AddSupernetValidatorOperation = AddSupernetValidatorOperation;
class RemoveSupernetValidatorOperation extends ChainNetworkOperation {
    supernetId;
    nodeId;
    constructor(chain, supernetId, nodeId) {
        super(NetworkOperationType.RemoveSupernetValidator, chain);
        this.supernetId = supernetId;
        this.nodeId = nodeId;
    }
}
exports.RemoveSupernetValidatorOperation = RemoveSupernetValidatorOperation;
class CreateChainOperation extends ChainNetworkOperation {
    supernetId;
    chainName;
    vmId;
    genesisData;
    chainAssetId;
    fxIds;
    constructor(chain, supernetId, chainName, vmId, genesisData, chainAssetId = chain.assetId, fxIds = []) {
        super(NetworkOperationType.CreateChain, chain);
        this.supernetId = supernetId;
        this.chainName = chainName;
        this.vmId = new transaction_1.DynamicId(vmId);
        this.genesisData = genesisData;
        this.chainAssetId = chainAssetId;
        this.fxIds = fxIds;
    }
}
exports.CreateChainOperation = CreateChainOperation;
class CrossOperation {
    type = NetworkOperationType.Cross;
    range = NetworkOperationRange.Supernet;
    source;
    destination;
    assetId;
    amount;
    sendImportFee = true;
    constructor(source, destination, assetId, amount) {
        this.source = source;
        this.destination = destination;
        this.assetId = assetId;
        this.amount = amount;
    }
}
exports.CrossOperation = CrossOperation;
class CrossResumeOperation extends ChainNetworkOperation {
    source;
    destination;
    utxoSet;
    constructor(source, destination, utxoSet) {
        super(NetworkOperationType.CrossResume, destination);
        this.source = source;
        this.destination = destination;
        this.utxoSet = utxoSet;
    }
}
exports.CrossResumeOperation = CrossResumeOperation;
class DepositResumeOperation extends JEVMChainOperation {
    asset;
    amount;
    constructor(chain, asset, amount) {
        super(NetworkOperationType.DepositResume, chain);
        this.asset = asset;
        this.amount = amount;
    }
}
exports.DepositResumeOperation = DepositResumeOperation;
